import { Person } from "../domain/Person.model";

type Dictionary = {
  [key: string]: string;
};

const peopleAttributesDictionary: Dictionary = {
  id: 'PersonaID',
  name: 'Persona',
  cuit: 'CUIT',
  beneficiario: 'EsBeneficiario',
  cliente: 'EsCliente',
  proveedor: 'EsProveedor',
  agente: 'EsAgente',
};

export const createAdapterToFieldPersonEndpoint = (key: string): string => {
  return peopleAttributesDictionary[key];
}

export const createAdapterToPersonEndpoint = (person: Person) => {
  return {
    PersonaID: person.id ?? undefined,
    Persona: person.name,
    CUIT: person.cuit,
    EsBeneficiario: person.beneficiario ? 1 : 0,
    EsCliente: person.cliente ? 1 : 0,
    EsProveedor: person.proveedor ? 1 : 0,
    EsAgente: person.agente ? 1 : 0,
  }
}

export const createAdapterToPerson = (personEndpoint: any): Person => {
  return {
    id: personEndpoint.PersonaID,
    name: personEndpoint.Persona,
    cuit: personEndpoint.CUIT,
    beneficiario: !!personEndpoint.EsBeneficiario,
    cliente: !!personEndpoint.EsCliente,
    proveedor: !!personEndpoint.EsProveedor,
    agente: !!personEndpoint.EsAgente,
    type: personEndpoint.EsProveedor ? 'supplier' : personEndpoint.EsCliente ? 'customer' : 'customer'
  }
}
